import type { Event } from '@patsnap/tahiti-core';
import { FtoTaskStep } from '../enums';

export const FtoReportStateService = Symbol.for('FtoReportStateService');

export interface FtoReportStateService {
    /**
     * 获取当前步骤
     */
    getCurrentStep(): FtoTaskStep;

    /**
     * 进入下一步
     */
    next(): Promise<void>;

    /**
     * 返回上一步
     */
    previous(): Promise<void>;

    /**
     * 初始化报告
     */
    initialize(): Promise<void>;

    /**
     * 直接跳转到指定步骤
     * @param step 目标步骤
     */
    goToStep(step: FtoTaskStep): Promise<void>;

    /**
     * 状态变化事件
     */
    readonly onStateChange: Event<FtoTaskStep>;
}
